import React, { Component } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  Stack,
} from "@mui/material";

// Ícones MUI equivalentes para o fluxo geral de vendas
import StorefrontIcon from "@mui/icons-material/Storefront";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

class ComoFunciona extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passos: [
        {
          numero: "1",
          titulo: "Monte seu Catálogo Digital",
          descricao:
            "Cadastre seus produtos, adicione fotos, defina preços, variações (cores, tamanhos ou adicionais) e personalize seu link exclusivo para vender em minutos.",
          icone: <StorefrontIcon sx={{ color: "#7C3AED", fontSize: 28 }} />,
        },
        {
          numero: "2",
          titulo: "Receba Pedidos em Tempo Real",
          descricao:
            "Seus clientes compram direto pelo link da sua loja, QR Code ou através do balcão. O sistema avisa imediatamente cada nova venda confirmada.",
          icone: <NotificationsActiveIcon sx={{ color: "#7C3AED", fontSize: 28 }} />,
        },
        {
          numero: "3",
          titulo: "Gerencie e Entregue sem Complicação",
          descricao:
            "Acompanhe o painel de envios e entregas, atualize o status dos pedidos, controle seu estoque automaticamente e feche o caixa com precisão total.",
          icone: <PointOfSaleIcon sx={{ color: "#7C3AED", fontSize: 28 }} />,
        },
      ],
    };
  }

  render() {
    return (
      <Box
        component="section"
        id="como-funciona"
        sx={{ bgcolor: "#ffffff", py: { xs: 6, sm: 10 } }}
      >
        <Container maxWidth="xl">
          {/* Cabeçalho da Seção */}
          <Box sx={{ mx: "auto", maxWidth: "700px", textAlign: "center", mb: 8 }}>
            <Chip
              icon={<RocketLaunchIcon sx={{ color: "#7C3AED !important", fontSize: "16px" }} />}
              label="PRÁTICO, RÁPIDO E SEM BUROCRACIA"
              sx={{
                bgcolor: "rgba(124, 58, 237, 0.1)",
                color: "#7C3AED",
                fontWeight: 700,
                fontSize: "0.75rem",
                border: "1px solid rgba(124, 58, 237, 0.2)",
                mb: 2,
                px: 1,
              }}
            />

            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontWeight: 800,
                color: "#1E1B4B",
                fontSize: { xs: "2rem", sm: "2.5rem", lg: "2.75rem" },
                mb: 2,
                lineHeight: 1.2,
              }}
            >
              Comece a Vender Online e na Loja Física em Três Passos
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#464467",
                fontSize: { xs: "1rem", sm: "1.1rem" },
              }}
            >
              Seja para o seu e-commerce, loja de rua, prestação de serviços ou delivery, o <strong>FazPedido</strong> centraliza todas as suas vendas em um sistema único.
            </Typography>
          </Box>

          {/* Cartões de Passo a Passo */}
          <Grid container spacing={4}>
            {this.state.passos.map((passo, index) => (
              <Grid size={{ xs: 12, md: 4 }} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    height: "100%",
                    borderRadius: "20px",
                    border: "1px solid #E3E1F8",
                    bgcolor: "#F2F1FF",
                    p: 2,
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 12px 24px -8px rgba(124, 58, 237, 0.25)",
                      borderColor: "#7C3AED",
                    },
                  }}
                >
                  <CardContent sx={{ p: 3, display: "flex", flexDirection: "column", height: "100%" }}>
                    {/* Topo do Card: Ícone e Número Indicador */}
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ mb: 3 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          h: 56,
                          w: 56,
                          minWidth: 56,
                          minHeight: 56,
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "16px",
                          bgcolor: "rgba(124, 58, 237, 0.12)",
                        }}
                      >
                        {passo.icone}
                      </Box>
                      <Avatar
                        sx={{
                          bgcolor: "#ffffff",
                          color: "#7C3AED",
                          fontWeight: 800,
                          fontSize: "1rem",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                          border: "1px solid #E3E1F8",
                          width: 36,
                          height: 36,
                        }}
                      >
                        {passo.numero}
                      </Avatar>
                    </Stack>

                    {/* Título do Passo */}
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{
                        fontWeight: 700,
                        color: "#1E1B4B",
                        fontSize: "1.25rem",
                        mb: 1.5,
                      }}
                    >
                      {passo.titulo}
                    </Typography>

                    {/* Descrição */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#464467",
                        fontSize: "0.95rem",
                        lineHeight: 1.6,
                        flexGrow: 1,
                      }}
                    >
                      {passo.descricao}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    );
  }
}

export default ComoFunciona;